var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAttachmentPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99458 6.15072L6.25806 2.88725C6.66757 2.47774 7.2575 2.40347 7.66742 2.81298C8.07735 3.22249 8.00309 3.81284 7.59316 4.22234L4.18115 7.63435C3.58787 8.22764 2.40088 8.22764 1.65949 7.48582C0.917673 6.74401 0.917673 5.55744 1.51096 4.96416L4.92296 1.55215C5.43601 1.04845 6.12719 0.767721 6.84616 0.771025C7.56512 0.774329 8.2537 1.0614 8.76209 1.56979C9.27048 2.07818 9.55755 2.76676 9.56085 3.48572C9.56416 4.20469 9.28342 4.89587 8.77973 5.40891L6.85134 7.33729",
    stroke: "#CECECE",
    strokeWidth: 0.839156,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttachmentPin);
export default __webpack_public_path__ + "static/media/icon-attachment-pin.33dde7876b103a5b9d26c34cdb5824f4.svg";
export { ForwardRef as ReactComponent };